document.addEventListener('DOMContentLoaded', async () => {
    if (!sessionStorage.getItem('autoLoginChecked')) {
        sessionStorage.setItem('autoLoginChecked', '1');
        autoLogin();
    }

    if (document.querySelector('header')) {
        try {
            const response = await fetch('/system/user/system/header-dom.php');
            const result = await response.json();
            if (result.success) {
                document.getElementById('header-btns').innerHTML = result.headerBtns;
                hamburgerEvent();
                document.getElementById('header-menu').innerHTML = result.menuList;
                if (document.getElementById('logout')) {
                    document.getElementById('logout').addEventListener('click', logoutClick);
                }
                if (document.getElementById('ticket-accordion')) {
                    document.getElementById('ticket-accordion').addEventListener('click', storeClickEvent);
                }
            } else {
                console.error('エラーが起きました：', result.message);
            }
        } catch (e) {
            console.error('エラーが起きました：', e.message)
        }
    }
    if (document.querySelector('footer')) {
        try {
            const response = await fetch('/system/user/system/footer-dom.php');
            const result = await response.json();
            if (result.success) {
                document.getElementById('f-menu-top').innerHTML = result.menuList;
            } else {
                console.error('エラーが起きました：', result.message);
            }
        } catch (e) {
            console.error('エラーが起きました：', e.message)
        }
    }

    // ページトップへ
    const pageTopButton = document.getElementById('page-top');
    if(pageTopButton){
        pageTopButton.addEventListener('click', function (event) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
})

// ハッシュが付いていた時にヘッダー分の高さを引く
window.addEventListener('load', () => {
  const hash = location.hash;
  if (!hash) return;

  const target = document.querySelector(hash);
  if (!target) return;

  // ヘッダー高さを取得
  const header = document.querySelector('header');
  const headerHeight = header ? header.offsetHeight : 0;

  // 位置計算
  const rect = target.getBoundingClientRect();
  const offsetTop = window.pageYOffset + rect.top - headerHeight;

  // スクロール補正
  window.scrollTo({
    top: offsetTop,
    behavior: 'instant' // ページロード時は即時が自然
  });
});

async function autoLogin(){
    const req = await fetch('/system/user/login/auto-login.php');
    const res = await req.json();
    if(res.success){
        window.location.reload();
    }
}

//ヘッダーメニュー
function hamburgerEvent() {
    document.getElementById('hamburger-btn').addEventListener('click', function () {
        this.classList.toggle('active');
        document.getElementById('header-menu').classList.toggle('active');
    });
};

// ログインセッション管理
export async function loginSession() {
    try {
        const response = await fetch('/system/user/system/session-check.php');
        const data = await response.json();
        return data.loggedIn || false;
    } catch (error) {
        console.error('エラー:', error);
        return false;
    }
}

// ログアウト処理
async function logoutClick(event) {
    event.preventDefault();
    try {
        // ログアウト処理をPHPにリクエスト
        const response = await fetch('/system/user/system/logout.php', {
            method: 'POST',
        });

        if (response.ok) {
            // ログアウト成功後、トップページやログインページにリダイレクト
            window.location.href = '/';
        } else {
            alert('ログアウトに失敗しました');
        }
    } catch (error) {
        console.error('エラーが発生しました:', error);
        alert('エラーが発生しました。再試行してください。');
    }
};

export async function logout(){
    const response = await fetch('/system/user/system/logout.php');
    if(response.ok){
        window.location.href = '/login/';
    }
}

// 2択モーダル
export class NormalModal {
    constructor(message, confirmText, onConfirm) {
        this.message = message;
        this.confirmText = confirmText;
        this.onConfirm = onConfirm;
        this.render();
    }

    render() {
        // モーダル要素を作成
        this.modal = document.createElement('div');
        this.modal.classList.add('modal-overlay');
        this.modal.innerHTML = `
            <div class="modal">
                <p class="modal-message">${this.message}</p>
                <div class="modal-buttons">
                    <button class="modal-cancel">キャンセル</button>
                    <button class="modal-confirm">${this.confirmText}</button>
                </div>
            </div>
        `;

        // ボタンのイベントリスナーを設定
        this.modal.querySelector('.modal-cancel').addEventListener('click', () => this.close());
        this.modal.querySelector('.modal-confirm').addEventListener('click', () => {
            if (typeof this.onConfirm === 'function') {
                this.onConfirm();
            }
            this.close();
        });
        document.querySelector('main').appendChild(this.modal);
    }

    close() {
        this.modal.remove();
    }
}

// スキー場メニューアコーディオン
function storeClickEvent(event) {
    const btn = event.target;
    const elm = event.target.nextElementSibling;
    let h = 0;

    if (!elm.classList.contains('open')) {
        // 開くとき
        elm.style.height = 'auto';
        h = elm.offsetHeight;
        elm.style.height = '0px';
        elm.offsetHeight;

        elm.animate({ height: ['0px', h + 'px'] }, { duration: 300 });

        elm.style.height = h + 'px';
        elm.classList.add('open');
        btn.classList.add('open');
    } else {
        // 閉じるとき
        h = elm.offsetHeight;
        elm.style.height = h + 'px';
        elm.offsetHeight;

        elm.animate({ height: [h + 'px', '0px'] }, { duration: 300 });

        elm.style.height = '0px';
        elm.classList.remove('open');
        btn.classList.remove('open');
    }
}


// ロードアニメーション
export function jsLoadAnim(elm) {
    // すでにローディングアニメーションが存在する場合は何もしない
    if (elm.querySelector('.js-load-anim')) return;

    const loadDom = document.createElement('div');
    loadDom.classList.add('js-load-anim');
    for (let i = 0; i < 8; i++) {
        const span = document.createElement('span');
        loadDom.appendChild(span);
    }
    elm.appendChild(loadDom);
}

export function jsDeleteLoadAnim(elm) {
    const elements = elm.querySelectorAll('.js-load-anim');
    elements.forEach(element => {
        element.remove();
    });
}